// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1vItC","col":"styles_col__S9amF"};